import React, { memo } from 'react'
import { useMatchMedia } from '../../hooks/useMatchMedia'
import Label from '../Label'

const Filters = ({ data }) => {
  const { isMatching, calculated } = useMatchMedia('(max-width:610px)', true)

  const renderItem = (label, description) => (
    <div className="flters-item">
      <Label text={label} />
      <p className="p p-16">{description}</p>
    </div>
  )
  return !isMatching && calculated ? (
    <section className="filters-section">
      <div className="container">
        <div className="filters-container">
          {data.map((filter) =>
            renderItem(
              filter.filters_label.text,
              filter.filters_description.text,
            ),
          )}
        </div>
      </div>
    </section>
  ) : null
}

export default memo(Filters)
